var COLORS;
(function (COLORS) {
    COLORS["trace"] = "lightblue";
    COLORS["info"] = "#ffa700";
    COLORS["error"] = "#d23432";
})(COLORS || (COLORS = {}));
const isApiError = (msg) => {
    return typeof msg !== "string";
};
class Logger {
    static generateMessage(color, message, base) {
        const errorMessage = isApiError(message) ? message.data?.errors[0]?.text : message;
        console.log(`%c ${base} ${errorMessage}`, `color: ${color};`);
    }
    trace = (message) => Logger.generateMessage(COLORS.trace, message, "trace:");
    info = (message) => Logger.generateMessage(COLORS.info, message, "info:");
    error = (message) => Logger.generateMessage(COLORS.error, message, "error:");
}
export default new Logger();
